import clsx from "clsx";

export const MODAL_CLASSES = {
  panel: clsx("mx-auto max-w-2xl w-full bg-white rounded-xl shadow-raro"),
  header: clsx("flex justify-between items-start mb-4"),
  title: clsx("text-xl font-semibold text-raro-gray-900 font-montserrat"),
  subtitle: clsx("text-sm text-raro-gray-500 mt-1"),
  closeButton: clsx(
    "text-raro-gray-400 hover:text-raro-gray-500 transition-colors"
  ),
  fieldLabel: clsx("text-sm font-medium text-raro-gray-500 font-montserrat"),
  fieldValue: clsx("mt-1 text-sm text-raro-gray-900"),
  sectionTitle: clsx(
    "text-sm font-medium text-raro-gray-500 mb-2 font-montserrat"
  ),
  resourceCard: clsx("bg-raro-gray-50 p-3 rounded-lg"),
  resourceType: clsx("text-sm font-medium text-raro-gray-900"),
  resourceDetails: clsx("text-sm text-raro-gray-500"),
  quantityBadge: clsx(
    "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium",
    "bg-primary-100 text-primary-800"
  ),
  notes: clsx("text-sm text-raro-gray-900 whitespace-pre-wrap"),
};
